export function getAppendedFilteredItems(extraItems, lastStoredItems) {
  if (lastStoredItems && extraItems) {
    return lastStoredItems.concat(extraItems);
  }
  return extraItems;
}
